import { FaRegArrowAltCircleRight } from "react-icons/fa";

import { Deal } from "@Types/deal";
import Button from "@Components/Button";
import IconButton from "@Components/IconButton";
import { formatFirstAndLastNames } from "@Utils/functions";

import styles from "./Application.module.scss";

const ApplicationPreview = ({
  deal,
  selectType,
  handleClick,
}: {
  deal: Deal;
  selectType: "icon" | "button";
  handleClick: (deal: Deal) => void;
}) => {
  return (
    <div className={styles.applicationPreivew}>
      <div className={styles.preview}>
        <div className={styles.description}>VIN</div>
        <div className={styles.value}>{deal.data.info.vehicle.VIN ?? ""}</div>
      </div>
      <div className={styles.preview}>
        <div className={styles.description}>Type</div>
        <div className={styles.value}>
          {deal.data.info.type.slice(0, 3).toUpperCase()}
        </div>
      </div>
      <div className={styles.preview}>
        <div className={styles.description}>Customer</div>
        <div className={styles.value}>
          {formatFirstAndLastNames(
            deal.data.applicant.data.info.firstName,
            deal.data.applicant.data.info.lastName
          )}
        </div>
      </div>
      {selectType === "button" ? (
        <Button
          className={styles.button}
          variant="blue"
          onClick={() => handleClick(deal)}
        >
          Select
        </Button>
      ) : (
        <IconButton onClick={() => handleClick(deal)}>
          <FaRegArrowAltCircleRight size={25} color="#6b97f6" />
        </IconButton>
      )}
    </div>
  );
};

export default ApplicationPreview;
